import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer, Provider } from '@angular/core';
import { KlaviyoEventCustomerDataTrigger } from './event/customer-data/klaviyo-event-customer-data.trigger';
import { KlaviyoEventLoginTrigger } from './event/login/klaviyo-event-login.trigger';
import { KlaviyoTrackingService } from './klaviyo-tracking.service';
import './klaviyo.interfaces';

export function provideKlaviyo(): EnvironmentProviders {
    const providers: (Provider | EnvironmentProviders)[] = [
        // {
        //     provide: OPTIONS,
        //     useFactory: () => {
        //         return defaultsDeep(config || {}, {
        //             enabled: false
        //         });
        //     }
        // }
    ];

    if (typeof window !== 'undefined') {
        providers.push(
            provideAppInitializer(() => {
                inject(KlaviyoTrackingService);
                inject(KlaviyoEventLoginTrigger);
                inject(KlaviyoEventCustomerDataTrigger);
            })
        );
    }

    return makeEnvironmentProviders(providers);
}
